import type { CSSProperties } from 'react';

// Shared backdrop for transient overlays (Dialog, AlertDialog, Sheet).
// Theme-aware wash (cream in light, ink in dark — see --overlay-bg in
// globals.css) + 2px blur, with a 32px blueprint-grid motif painted on
// top. The grid uses --grid-line-strong, which is also theme-aware
// (dark hairlines on cream, light hairlines on ink), so the motif
// reads on either backdrop.
export const OVERLAY_CLASS =
  'fixed inset-0 z-50 bg-[color-mix(in_oklab,var(--overlay-bg)_92%,transparent)] backdrop-blur-[2px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0';

export const OVERLAY_GRID_BG: CSSProperties = {
  backgroundImage:
    'linear-gradient(var(--grid-line-strong) 1px, transparent 1px), linear-gradient(90deg, var(--grid-line-strong) 1px, transparent 1px)',
  backgroundSize: '32px 32px',
  backgroundPosition: '-1px -1px',
};
